import React from 'react';

import {Group} from '@pb/kit-component-group';
import Loading, {Types} from '@pb/kit-component-loading';

import {HEADERS} from '../../constants';

type Props = {
    columnId: string,
};

export const HeaderSkeleton = ({columnId}: Props) => (
    <Group alignItems="center">
        <Loading type={Types.ICON}/>
        <strong>{HEADERS[columnId]}</strong>
    </Group>
);
